import { produce } from 'immer'
import { str } from './utils'
import { registrationInviteActions } from '../actions/registrationInvite'
import {
  SET_INVITE_STEP,
  SET_INVITE_LOGGED,
  SET_INVITE_SPORTS,
  SET_NEW_TEAM_ID,
  SET_TEAM_PLAYER_ROSTER_ID,
  CLEAR_INVITE_ERROR,
} from '../actions/registrationInvite'
import authActions from '../actions/auth'

const initialState = {
  step: 0,
  isLogged: false,
  eventInfo: {},
  user: {
    email: '',
    password: '',
    token: '',
  },
  userExtraInfo: {},
  playerExtraInfo: {},
  userTeams: [],
  playerTeams: [],
  skillLevels: [],
  isLoading: true,
  isLoadingStep: false,
  error: null,
  newTeamId: null,
  selectedTeamPlayerRosterId: null,
  sports: [],
  submittedInfo: {
    divisionId: null,
    teamName: '',
    teamLogo: undefined,
    costPerTeam: '',
    deposit: '',
    divisionName: '',
    teamId: '',
    billingInfo: null,
    singlePayment: false,
  },
}

export default (state = initialState, { type, payload }) =>
  produce(state, (draft) => {
    switch (type) {
      // fetchEventInfo
      case str(registrationInviteActions.fetchEventInfo.request):
        draft.isLoading = true
        return
      case str(registrationInviteActions.fetchEventInfo.success):
        draft.eventInfo = payload.invite
        draft.isLogged = payload.isLogged
        draft.isLoading = false
        return
      case str(registrationInviteActions.fetchEventInfo.failure):
        draft.error = payload?.error?.message || 'Failed to load event'
        draft.isLoading = false
        return

      // confirmTeamRepStep
      case str(registrationInviteActions.confirmTeamRepStep.request):
        draft.isLoadingStep = true
        return
      case str(registrationInviteActions.confirmTeamRepStep.success):
        if (payload.user) {
          draft.userExtraInfo = payload.user
        }
        draft.userTeams = payload.teams
        draft.step = 1
        draft.isLoadingStep = false
        return
      case str(registrationInviteActions.confirmTeamRepStep.failure):
        draft.isLoadingStep = false
        return

      // confirmPlayerStep
      case str(registrationInviteActions.confirmPlayerStep.request):
        draft.isLoadingStep = true
        return
      case str(registrationInviteActions.confirmPlayerStep.success):
        if (payload.user) {
          draft.userExtraInfo = payload.user
        }
        draft.playerExtraInfo = payload.player
        draft.playerTeams = payload.teams
        draft.skillLevels = payload.skillLevel
        draft.step = 4
        draft.isLoadingStep = false
        return
      case str(registrationInviteActions.confirmPlayerStep.failure):
        draft.isLoadingStep = false
        return

      // confirmTeamAndDivisionSelect
      case str(registrationInviteActions.confirmTeamAndDivisionSelect.request):
        draft.isLoadingStep = true
        draft.error = null
        return
      case str(
        registrationInviteActions.confirmTeamAndDivisionSelect.success
      ):
        draft.step = 2
        draft.submittedInfo = {
          ...draft.submittedInfo,
          ...payload.info,
          billingInfo: payload.billing,
        }
        draft.isLoadingStep = false
        return
      case str(
        registrationInviteActions.confirmTeamAndDivisionSelect.failure
      ):
        draft.error = payload?.error?.message || 'Register Failed'
        draft.isLoadingStep = false
        return

      // confirmPlayerSelect
      case str(registrationInviteActions.confirmPlayerSelect.request):
        draft.isLoadingStep = true
        return
      case str(registrationInviteActions.confirmPlayerSelect.success):
        draft.step = 2
        draft.submittedInfo = {
          ...draft.submittedInfo,
          ...payload.playerInfo,
          ...payload.endpointInfo,
        }
        draft.isLoadingStep = false
        return
      case str(registrationInviteActions.confirmPlayerSelect.failure): {
        const err = payload?.error
        draft.step = 3
        draft.error =
          err?.statusCode === 422 ? err?.message : 'Register Failed'
        draft.isLoadingStep = false
        return
      }

      // Simple actions
      case SET_INVITE_STEP:
        draft.step = payload
        return
      case SET_INVITE_LOGGED:
        draft.isLogged = payload
        return
      case SET_INVITE_SPORTS:
        draft.sports = payload
        return
      case SET_NEW_TEAM_ID:
        draft.newTeamId = payload
        return
      case SET_TEAM_PLAYER_ROSTER_ID:
        draft.selectedTeamPlayerRosterId = payload
        draft.step = 4.5
        return
      case CLEAR_INVITE_ERROR:
        draft.error = null
        return

      case str(authActions.logout.success):
        return initialState
    }
  })
